(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(factory());
}(this, (function () { 'use strict';

$(function () {
  $('#loading-page #loading-inner img').velocity({
    top: ['50%', '53%']
  }, { easing: 'easeInOut', duration: 900, loop: true });
});

$(".animation , .star-wrap > div").css('opacity', '0');

$(window).load(function () {
  $('.content-header #jp_container_1').css('opacity' , '1');
  // var path_video = '/pub/machine / uruseiyatsura / sound /';
  var bgm_path = './sound/';
  if (!$.cookie("bgm")) {
    $.cookie("bgm", "bgm_1.mp3");
  }
  var bgm_name = $.cookie("bgm");

  var stream = {
    mp3: bgm_path + bgm_name
  },
      _ready = false;

  var setVideostream = function setVideostream(_bgm_name) {
    stream.mp3 = bgm_path + _bgm_name;
  };
  $("#jquery_jplayer_1").jPlayer({
    ready: function ready(event) {
      _ready = true;
      $(this).jPlayer("setMedia", stream).jPlayer('stop');

      $(".x_video").click(function (e) {
        e.preventDefault();
        // console.log(stream.mp3, $(this).attr('href'))
        if ($(this).hasClass('is_active')) {
          $(".x_video").removeClass('is_active');
          $.cookie("bgm_status", "pause");
          $("#jquery_jplayer_1").jPlayer("setMedia", stream).jPlayer("pause");
        } else {
          $(".x_video").removeClass('is_active');
          $(this).addClass('is_active');
          setVideostream($(this).attr('href'));
          $.cookie("bgm", $(this).attr('href'));
          $("#jquery_jplayer_1").jPlayer("setMedia", stream).jPlayer("play");
        }
      });
      $(".sound-page a.sound-on").click(function () {
        var video = document.getElementById("video");
        video.play();
        video.muted = false;
        video.onended = function (e) {
          $("#jquery_jplayer_1").jPlayer("play");
          $("#loader-bg").hide();
        };
      });
      if ($.cookie("bgm_status") == "pause") {
        $("#jquery_jplayer_1").jPlayer("setMedia", stream).jPlayer("pause");
      } else {
        $("#jquery_jplayer_1").jPlayer("setMedia", stream).jPlayer("play");
        for (var i = 0; i < $(".x_video").length; i++) {
          if ($(".x_video").eq(i).attr("href") == bgm_name) {
            $(".x_video").eq(i).addClass('is_active');
          }
        }
      }
    },
    pause: function pause() {
      $.cookie("bgm_status", "pause");
    },
    play: function play() {
      $.cookie("bgm_status", "play");
      // $('.video-item a').click(function() {
      //   // $("#jquery_jplayer_1").jPlayer("pause");
      // });
    },
    error: function error(event) {
      // console.log('error');
      if (_ready && event.jPlayer.error.type === $.jPlayer.error.URL_NOT_SET) {
        $(this).jPlayer("setMedia", stream).jPlayer("play");
      }
    },
    ended: function ended() {
      // console.log('ended');
      $(this).jPlayer("setMedia", stream).jPlayer("play");
    },
    swfPath: "js",
    supplied: "mp3",
    preload: "none",
    wmode: "window",
    loop: true,
    volume: 1,
    keyEnabled: true
  });

  $("#jp_container_1").click(function () {
    $(".sound-page").css("display", "none");
  });

  $("#loading-page").delay(400).fadeOut(300);
  $("#loading-inner").delay(400).fadeOut(300);

  if ($.cookie("access") == undefined) {
    var topanime = function topanime() {
      //ローディングページ
      $('.urusei-wrap')
      //.velocity({opacity: [0]})
      .delay(800).velocity({
        opacity: ['1', '0']
      }, { easing: 'easeInOut', duration: 3000 });

      $('.urusei-object')
      //.velocity({opacity: [0]})
      .delay(800).velocity({
        scale: ['1', '0.8'], translateY: ['-300px', '-440px']
      }, { easing: 'easeInOut', duration: 2000 });

      //$('.black-area').delay(11400).velocity({
      $('.black-area').delay(13000).velocity({
        opacity: [1, 0]
      }, { easing: 'easeInOut', duration: 1500 });

      //$("#loader-bg").delay(12400).fadeOut(2000);
      //$("#loader-bg").delay(15200).fadeOut(1);
      //$("#loader-bg").delay(14400).css('display','none');

      // 星
      $(".star-bg_01").delay(14500).velocity({
        'top': ['-100px', '-300px'], 'left': ['0', '-200px'], opacity: [1, 0]
      }, { easing: 'easeInOut', duration: 2500 });

      $(".star-bg_02").delay(14500).velocity({
        'top': ['-100px', '-200px'], 'left': ['0', '-100px'], opacity: [1, 0]
      }, { easing: 'easeInOut', duration: 2400 });

      $(".star-bg_03").delay(14500).velocity({
        'top': ['-100px', '-150px'], 'left': ['0', '-50px'], opacity: [1, 0]
      }, { easing: 'easeInOut', duration: 2300 });

      $(".star-bg_04").delay(14500).velocity({
        'bottom': ['-50px', '-250px'], 'left': ['-200px', '0px'], opacity: [1, 0]
      }, { easing: 'easeInOut', duration: 2500 });

      $(".star-bg_05").delay(14500).velocity({
        'bottom': ['-50px', '-100px'], 'left': ['-200px', '-150px'], opacity: [1, 0]
      }, { easing: 'easeInOut', duration: 2400 });

      $(".star-bg_06").delay(14500).velocity({
        'top': ['30px', '0px'], 'left': ['10%', '5%'], opacity: [1, 0]
      }, { easing: 'easeInOut', duration: 2300 });

      $(".star-bg_07").delay(14500).velocity({
        'top': ['40px', '-10px'], 'left': ['90%', '85%'], opacity: [1, 0]
      }, { easing: 'easeInOut', duration: 2300 });

      $(".star-bg_08").delay(14500).velocity({
        'top': ['100px', '70px'], 'left': ['95%', '90%'], opacity: [1, 0]
      }, { easing: 'easeInOut', duration: 2300 });

      $(".star-bg_09").delay(14500).velocity({
        'top': ['20px', '0px'], 'left': ['40%', '35%'], opacity: [1, 0]
      }, { easing: 'easeInOut', duration: 2300 });

      $(".star-bg_10").delay(14500).velocity({
        'top': ['430px', '380px'], 'left': ['90%', '85%'], opacity: [1, 0]
      }, { easing: 'easeInOut', duration: 2300 });

      // 星ゆらゆら
      $(".star-bg_01 .star").delay(17000).velocity({
        top: ['-20px', '0']
      }, { easing: 'easeInOut', duration: 2000, loop: true });

      $(".star-bg_02 .star").delay(16900).velocity({
        top: ['-20px', '0']
      }, { easing: 'easeInOut', duration: 2500, loop: true });

      $(".star-bg_03 .star").delay(16800).velocity({
        left: ['-90px', '-100px']
      }, { easing: 'easeInOut', duration: 3000, loop: true });

      $(".star-bg_04 .star").delay(17000).velocity({
        top: ['-30px', '0']
      }, { easing: 'easeInOut', duration: 2200, loop: true });

      $(".star-bg_05 .star").delay(16900).velocity({
        left: ['-80px', '-100px']
      }, { easing: 'easeInOut', duration: 3500, loop: true });

      $(".cara-lamu").delay(15500).velocity({
        scale: [1, 0.8], 'top': ['-80px', '-180px'], 'left': ['-230px', '-300px'], opacity: [1, 0]
      }, { easing: 'easeOut', duration: 1000 });

      $(".page-index .content-body-wrapper .title").delay(15800).velocity({
        scale: [1, 5], opacity: [1, 0]
      }, { easing: 'easeInOut', duration: 500 });

      $(".video-list .video-item:first-child").delay(16000).velocity({
        scale: [1, 5], opacity: [1, 0]
      }, { easing: 'easeInOut', duration: 200 });

      $(".video-list .video-item:nth-child(2)").delay(16200).velocity({
        scale: [1, 5], opacity: [1, 0]
      }, { easing: 'easeInOut', duration: 200 });

      $(".link-list .link-item:first-child").delay(16400).velocity({
        scale: [1, 5], opacity: [1, 0]
      }, { easing: 'easeInOut', duration: 200 });

      $(".link-list .link-item:nth-child(2)").delay(16600).velocity({
        scale: [1, 5], opacity: [1, 0]
      }, { easing: 'easeInOut', duration: 200 });
    };

    $.cookie("access", "onece");
    $(".page-index #loader-bg").css("display", "none");
    $(".sound-page").css("display", "block");

    $(".sound-page a.sound-on").click(function () {
      $(".page-index #loader-bg").css("display", "block");
      $(".page-index .loader-bg01").css("display", "block");

      $(".sound-page").fadeOut(300);
      topanime();
    });

    $(".sound-page a.sound-off").click(function () {
      $(".page-index #loader-bg").css("display", "block");
      $(".page-index .loader-bg02").css("display", "block");
      $(".sound-page").fadeOut(300);
      $("#loader-bg").delay(15200).fadeOut(1);
      topanime();
    });
  } else {

    $("#loader-bg").css("display", "none");
    $("#loading-page").delay(400).fadeOut(300);
    $("#loading-inner").delay(400).fadeOut(300);

    $(".star-bg_01").delay(500).velocity({
      'top': ['-100px', '-300px'], 'left': ['0', '-200px'], opacity: [1, 0]
    }, { easing: 'easeInOut', duration: 2500 });

    $(".star-bg_02").delay(500).velocity({
      'top': ['-100px', '-200px'], 'left': ['0', '-100px'], opacity: [1, 0]
    }, { easing: 'easeInOut', duration: 2400 });

    $(".star-bg_03").delay(500).velocity({
      'top': ['-100px', '-150px'], 'left': ['0', '-50px'], opacity: [1, 0]
    }, { easing: 'easeInOut', duration: 2300 });

    $(".star-bg_04").delay(500).velocity({
      'bottom': ['-50px', '-250px'], 'left': ['-200px', '0px'], opacity: [1, 0]
    }, { easing: 'easeInOut', duration: 2500 });

    $(".star-bg_05").delay(500).velocity({
      'bottom': ['-50px', '-100px'], 'left': ['-200px', '-150px'], opacity: [1, 0]
    }, { easing: 'easeInOut', duration: 2400 });

    $(".star-bg_06").delay(500).velocity({
      'top': ['30px', '0px'], 'left': ['10%', '5%'], opacity: [1, 0]
    }, { easing: 'easeInOut', duration: 2300 });

    $(".star-bg_07").delay(500).velocity({
      'top': ['40px', '-10px'], 'left': ['90%', '85%'], opacity: [1, 0]
    }, { easing: 'easeInOut', duration: 2300 });

    $(".star-bg_08").delay(500).velocity({
      'top': ['100px', '70px'], 'left': ['95%', '90%'], opacity: [1, 0]
    }, { easing: 'easeInOut', duration: 2300 });

    $(".star-bg_09").delay(500).velocity({
      'top': ['20px', '0px'], 'left': ['40%', '35%'], opacity: [1, 0]
    }, { easing: 'easeInOut', duration: 2300 });

    $(".star-bg_10").delay(500).velocity({
      'top': ['430px', '380px'], 'left': ['90%', '85%'], opacity: [1, 0]
    }, { easing: 'easeInOut', duration: 2300 });

    // 星ゆらゆら
    $(".star-bg_01 .star").delay(3000).velocity({
      top: ['-20px', '0']
    }, { easing: 'easeInOut', duration: 2000, loop: true });

    $(".star-bg_02 .star").delay(2900).velocity({
      top: ['-20px', '0']
    }, { easing: 'easeInOut', duration: 2500, loop: true });

    $(".star-bg_03 .star").delay(2800).velocity({
      left: ['-90px', '-100px']
    }, { easing: 'easeInOut', duration: 3000, loop: true });

    $(".star-bg_04 .star").delay(3000).velocity({
      top: ['-30px', '0']
    }, { easing: 'easeInOut', duration: 2200, loop: true });

    $(".star-bg_05 .star").delay(2900).velocity({
      left: ['-80px', '-100px']
    }, { easing: 'easeInOut', duration: 3500, loop: true });

    $(".cara-lamu").delay(2500).velocity({
      scale: [1, 0.8], 'top': ['-80px', '-180px'], 'left': ['-230px', '-300px'], opacity: [1, 0]
    }, { easing: 'easeOut', duration: 1000 });

    $(".page-index .content-body-wrapper .title").delay(2800).velocity({
      scale: [1, 5], opacity: [1, 0]
    }, { easing: 'easeInOut', duration: 500 });

    $(".video-list .video-item:first-child").delay(3000).velocity({
      scale: [1, 5], opacity: [1, 0]
    }, { easing: 'easeInOut', duration: 200 });

    $(".video-list .video-item:nth-child(2)").delay(3200).velocity({
      scale: [1, 5], opacity: [1, 0]
    }, { easing: 'easeInOut', duration: 200 });

    $(".link-list .link-item:first-child").delay(3400).velocity({
      scale: [1, 5], opacity: [1, 0]
    }, { easing: 'easeInOut', duration: 200 });

    $(".link-list .link-item:nth-child(2)").delay(3600).velocity({
      scale: [1, 5], opacity: [1, 0]
    }, { easing: 'easeInOut', duration: 200 });
  }
});

})));
//# sourceMappingURL=application_add.js.map



//ストーリー
$('.page-story .content-body-wrapper > div').css('opacity' , '0');
$(window).load(function () {
  $('.page-story').one('inview', function(event, isInView) {
    $('.page-story .content-1')
      .delay(500)
      .velocity({scale: [1, 0.5], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });

    $('.page-story .content-2')
      .delay(600)
      .velocity({top: [0, 10], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });

    $('.page-story .content-3')
      .delay(700)
      .velocity({top: [0, 10], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });

    $('.page-story .content-5')
      .delay(800)
      .velocity({scale: [1, 3], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });
  });

  $('.page-story .content-7').one('inview', function(event, isInView) {
    $('.page-story .content-4')
      .delay(500)
      .velocity({top: ['0', '20'],left: ['0', '-100'], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:100 });

    $('.page-story .content-6')
      .delay(600)
      .velocity({top: ['0', '20'],left: ['0', '-100'], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });

    $('.page-story .content-7')
      .delay(700)
      .velocity({top: ['0', '20'],left: ['0', '-100'], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });

    $('.page-story .content-8')
      .delay(800)
      .velocity({scale: [1, 3], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });
  });
});

//キャラクター
$('.page-character .content-body-wrapper .title,.page-character .content-body-wrapper > img').css('opacity' , '0');
$(window).load(function () {
  $('.page-character .content-body-wrapper .title').one('inview', function(event, isInView) {
    $('.page-character .content-body-wrapper .title')
      .delay(500)
      .velocity({scale: [1, 3], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });

    $('.page-character .content-body-wrapper > img')
      .delay(600)
      .velocity({scale: [1, 3], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });
  });
});



//ミュージックページ
$('.page-music .content-body-wrapper > div').css('opacity' , '0');
$(window).load(function () {
  $('.page-music .content-1').one('inview', function(event, isInView) {
    $('.page-music .content-1')
      .delay(800)
      .velocity({top: [0, 10], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:400 });

    $('.page-music .content-2')
      .delay(500)
      .velocity({scale: [1, 3], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });
  });
});


//特徴
$('.is-feture .content-body-wrapper > div,.is-feture .content-6 img').css('opacity' , '0');
$(window).load(function () {
  $('.is-feture .content-1').one('inview', function(event, isInView) {
    $('.is-feture .content-1')
      .delay(500)
      .velocity({left: ['0', '-50'], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });

    $('.is-feture .content-2')
      .delay(600)
      .velocity({left: ['0', '-50'],top: [0, 10], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });

    $('.is-feture .content-4')
      .delay(700)
      .velocity({scale: [1, 3], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });
    $('.is-feture .content-9')
      .delay(800)
      .velocity({top: [0, -20], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:1000 });
  });
  $('.is-feture .content-6').one('inview', function(event, isInView) {
    $('.is-feture .content-6')
      .delay(0)
      .velocity({opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:0 });
    $('.is-feture .content-6 img:first-child')
      .delay(500)
      .velocity({right: ['-167', '-200'],top: [0, -10], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });

    $('.is-feture .content-6 img:last-child')
      .delay(800)
      .velocity({scale: [1, 3], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });
  });
  $('.is-feture .content-7').one('inview', function(event, isInView) {
    
    $('.is-feture .content-7')
      .delay(600)
      .velocity({left: ['-35', '-80'],top: [0, 10], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });

    $('.is-feture .content-8')
      .delay(700)
      .velocity({right: ['0', '-80'],top: [0, -10], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });
    
  });
});


//スペック
$('.contents-spec .content-body-wrapper > div').css('opacity' , '0');
$(window).load(function () {
  $('.contents-spec .content-1').one('inview', function(event, isInView) {
    $('.contents-spec .content-1')
      .delay(500)
      .velocity({left: ['0', '-50'],top: [0, 10], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });
  });
  $('.contents-spec .content-3').one('inview', function(event, isInView) {
    $('.contents-spec .content-3')
      .delay(500)
      .velocity({scale: [1, 3], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });

    $('.contents-spec .content-4')
      .delay(800)
      .velocity({right: ['0', '-80'],top: [0, -10], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });
    $('.contents-spec .content-5')
      .delay(900)
      .velocity({right: ['0', '-80'],top: [0, -10], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });
    $('.contents-spec .content-6')
      .delay(1000)
      .velocity({right: ['0', '-80'],top: [0, -10], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });
    $('.contents-spec .content-7')
      .delay(1100)
      .velocity({right: ['0', '-80'],top: [0, -10], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });
  });
  $('.contents-spec .content-10').one('inview', function(event, isInView) {
    $('.contents-spec .content-10')
      .delay(500)
      .velocity({scale: [1, 0.5], opacity: [1, 0]
      }, { easing: 'easeInOut' , duration:200 });
  });
});



